module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.18173/js/img/valuePropModals/ReportBuilder/ValueProp3.svg"